import { render, staticRenderFns } from "./CustomerForm.vue?vue&type=template&id=4bf14ea2&scoped=true&"
import script from "./CustomerForm.vue?vue&type=script&lang=js&"
export * from "./CustomerForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomerForm.vue?vue&type=style&index=0&id=4bf14ea2&prod&lang=scss&"
import style1 from "./CustomerForm.vue?vue&type=style&index=1&id=4bf14ea2&prod&scoped=true&lang=scss&"
import style2 from "./CustomerForm.vue?vue&type=style&index=2&id=4bf14ea2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf14ea2",
  null
  
)

export default component.exports